<div class="header">

  <div class="header-central">
    <div class="header-logo">
      <a href="/"><img src="/assets/images/logo-white.svg"/></a>
    </div>
    <div class="app-info">
      <div class="appName">
        <img style="width:20rem; height:1.5rem;" src="/assets/images/bsh-logo.svg"/>
      </div>
      @if (username) {
        <div class="show-username">
          <svg class="icon"><use xlink:href="/assets/icons/symbol-defs.svg#icon-icons-person-outline"></use></svg>
          {{username}}
        </div>
      }
      @if (!showSelectLanguage) {
        <div class="language-select" (click)="selectLanguage()">
          <svg class="icon"><use xlink:href="/assets/icons/symbol-defs.svg#icon-icons-language"></use></svg>
          {{userLanguage | uppercase}}
        </div>
      }
      @if (showSelectLanguage) {
        <div class="language-select-active" (click)="closeSelectLanguage()">
          <svg class="icon"><use xlink:href="/assets/icons/symbol-defs.svg#icon-icons-language"></use></svg>
          {{userLanguage | uppercase}}
          <div class="content-overlay"></div>
          <div class="header-overlay"></div>
          <div class="language-switch">
            <app-language-switch></app-language-switch>
          </div>
        </div>
      }
      @if (!username) {
        <div class="signIn" (click)="signIn()" translate>
          <svg class="icon"><use xlink:href="/assets/icons/symbol-defs.svg#icon-icons-login"></use></svg>
          common.signIn
        </div>
      }
      @if (username) {
        <div class="signOut" (click)="signOut()" translate>
          <svg class="icon"><use xlink:href="/assets/icons/symbol-defs.svg#icon-icons-logout"></use></svg>
          common.signOut
        </div>
      }
    </div>
  </div>

  <div class="navigation">
    <nav>
      <a routerLink="/overview" routerLinkActive="routerLinkActive" translate>navigation.releases</a>
      @if (userService.hasAnyRole([roles.SoftwareProductRead, roles.SoftwareProductWrite]) | async) {
        <a routerLink="/softwareProducts" routerLinkActive="routerLinkActive" translate>navigation.softwareProducts</a>
      }
      @if (userService.hasAnyRole([roles.PlatformRead, roles.PlatformWrite]) | async) {
        <a routerLink="/platforms" routerLinkActive="routerLinkActive" translate>navigation.platforms</a>
      }
      <a routerLink="/settings" routerLinkActive="routerLinkActive" translate>navigation.settings</a>
    </nav>
    <div class="nav-search">
      <app-searchbar></app-searchbar>
    </div>
  </div>
</div>